(() => {
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.querySelectorAll('form.js-contact-form').forEach((form) => {
    const success = form.querySelector('[data-form-success]');
    if (success) {
      success.focus();
      return;
    }

    const summary = form.querySelector('[data-error-summary]');
    const summaryList = form.querySelector('[data-error-list]');
    if (summary && !summary.hidden) summary.focus();

    const fields = {
      name: form.querySelector('[name="contact[name]"]'),
      email: form.querySelector('[name="contact[email]"]'),
      message: form.querySelector('[name="contact[body]"]'),
    };

    const labels = { name: 'Name', email: 'Email', message: 'Message' };

    const setError = (key, message) => {
      const input = fields[key];
      const error = form.querySelector(`[data-error-for="${key}"]`);
      if (!input || !error) return;
      if (message) {
        input.setAttribute('aria-invalid', 'true');
        error.textContent = message;
        error.hidden = false;
      } else {
        input.removeAttribute('aria-invalid');
        error.hidden = true;
      }
    };

    const validate = () => {
      const problems = [];
      if (!fields.name.value.trim()) problems.push(['name', 'Please enter your name.']);
      const email = fields.email.value.trim();
      if (!email) problems.push(['email', 'Please enter your email address.']);
      else if (!EMAIL_PATTERN.test(email)) problems.push(['email', 'Please enter a valid email address, like name@example.com.']);
      if (!fields.message.value.trim()) problems.push(['message', 'Please enter a message.']);
      return problems;
    };

    Object.entries(fields).forEach(([key, input]) => {
      input?.addEventListener('input', () => {
        if (input.getAttribute('aria-invalid') === 'true' && !validate().some(([k]) => k === key)) setError(key, '');
      });
    });

    form.addEventListener('submit', (event) => {
      const problems = validate();
      Object.keys(fields).forEach((key) => setError(key, ''));

      if (problems.length === 0) {
        form.querySelector('[type="submit"]')?.setAttribute('aria-busy', 'true');
        return;
      }

      event.preventDefault();
      problems.forEach(([key, message]) => setError(key, message));

      summaryList.innerHTML = '';
      problems.forEach(([key, message]) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${fields[key].id}`;
        link.textContent = `${labels[key]}: ${message}`;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          fields[key].focus();
        });
        item.appendChild(link);
        summaryList.appendChild(item);
      });
      summary.hidden = false;
      summary.focus();
    });
  });
})();
